
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.937.038a.399.399 0 01.308-.013.367.367 0 01.241.24l.755 2.371h2.36a.378.378 0 01.399.389.462.462 0 01-.157.314l-1.878 1.395.766 2.318a.41.41 0 01-.242.525h-.115a.556.556 0 01-.241-.084L20.14 6.014 18.136 7.44a.43.43 0 01-.566-.073.262.262 0 01-.073-.325l.755-2.308-1.993-1.384a.398.398 0 01-.126-.556.65.65 0 01.367-.158h2.476l.755-2.37c.035-.1.11-.183.206-.228z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M15 3H3C1.312 3 0 4.36 0 6v10.5c0 1.688 1.313 3 3 3h3v3.938c0 .375.234.562.563.562.093 0 .187 0 .328-.094L12.75 19.5h6.75c1.64 0 3-1.313 3-3V9H21v7.5c0 .844-.703 1.5-1.5 1.5h-7.266l-.421.328L7.5 21.563V18H3a1.48 1.48 0 01-1.5-1.5V6c0-.797.656-1.5 1.5-1.5h12V3z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M4.875 12.75h6.75c.188 0 .375.188.375.375v.75a.37.37 0 01-.375.375h-6.75c-.234 0-.375-.14-.375-.375v-.75a.37.37 0 01.375-.375zM14.625 8.25h-9.75a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h9.75A.37.37 0 0015 9.375v-.75a.403.403 0 00-.375-.375z","fill":"#586E8C"}})])
          )
        }
      }
    